/* eslint-disable no-console */
import { put, call, cancelled } from 'redux-saga/effects';
import notify from '../../lib/notifiy';
import actionConstants from '../constants';
import { COMMON_ERROR_CODES, HTTP_CODES } from '../../lib/constants';
import store from '../store';
import { abortApiRequest } from '../../api/requestCancellation';
// ------------------------------------
// Common Worker Saga
// ------------------------------------

const getFallbackErrorMessage = (error: any, defaultMessage: string): string => {
  const responseText = error?.response?.text;
  if (responseText) {
    const preMatch = responseText.match(/<pre>([\s\S]*?)<\/pre>/i);
    const message = preMatch?.[1] || responseText;
    return (
      message.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() ||
      defaultMessage
    );
  }
  return error?.message || defaultMessage;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function* workerSaga(action) {
  const {
    serviceMethod,
    actionTypeSuccess,
    actionTypeFailure,
    actionTypeRequest,
    extra,
    callback,
    genericErrorHandling = true,
    hideLoader,
    loaderMessage,
    cancelKey,
  } = action.payload;
  let loaderStarted = false;
  let loaderStopped = false;
  try {
    yield put({
      type: actionTypeRequest,
      payload: extra,
    });
    if (!hideLoader) {
      yield put({
        type: actionConstants.START_LOADER,
        payload: { actionType: actionTypeRequest, loaderMessage },
      });
      loaderStarted = true;
    }

    const apiResponse = yield call(serviceMethod);
    const body = apiResponse.body
      ? apiResponse.body
      : apiResponse.text
      ? JSON.parse(apiResponse.text)
      : {};
    if (!hideLoader) {
      yield put({
        type: actionConstants.STOP_LOADER,
        payload: { actionType: actionTypeRequest },
      });
      loaderStopped = true;
    }
    yield put({
      type: actionTypeSuccess,
      payload: { body, extra },
    });
    if (callback) callback();
  } catch (error: any) {
    if (loaderStarted && !loaderStopped) {
      yield put({
        type: actionConstants.STOP_LOADER,
        payload: { actionType: actionTypeRequest },
      });
      loaderStopped = true;
    }
    const statusCode = error?.response?.statusCode;
    const shouldForceLogout =
      !extra?.silentAuth &&
      (
        (
          store.getState().loginReducer.loginState.isUserAuthenticated &&
          statusCode === HTTP_CODES.FORBIDDEN_CODE
        ) ||
        statusCode === HTTP_CODES.UNAUTHORIZED_CODE
      );

    if (shouldForceLogout) {
      yield put({
        type: actionConstants.POST_LOGOUT_SUCCESS,
        payload: { body: true },
      });
    }
    if (error && error.response && error.response.body) {
      yield put({
        type: actionTypeFailure,
        payload: { body: error.response.body, extra },
      });
      // Common Generic Error Handling
      if (
        COMMON_ERROR_CODES[error.response.body.error_code] &&
        genericErrorHandling
      ) {
        notify({
          // description: store.getState().validationErrors.SOMETHING_WENT_WRONG,
          type: 'error',
          message:
            store.getState().validationReducer.validationErrorState
              .validationErrors.SOMETHING_WENT_WRONG ||
            'Something went wrong! Please try again.',
          description: '',
        });
      }
    } else {
      const defaultErrorMessage =
        store.getState().validationReducer.validationErrorState
          .validationErrors.SOMETHING_WENT_WRONG ||
        'Something went wrong! Please try again.';
      if (actionTypeFailure) {
        yield put({
          type: actionTypeFailure,
          payload: {
            body: {
              code: error?.response?.statusCode || error?.status || 0,
              message: getFallbackErrorMessage(error, defaultErrorMessage),
            },
            extra,
          },
        });
      }
      genericErrorHandling && notify({
        description:
          defaultErrorMessage,
        duration: 1,
        type: 'error',
        message: 'Error',
      });
      console.error(error);
    }
  } finally {
    if (yield cancelled()) {
      if (cancelKey) {
        abortApiRequest(cancelKey);
      }
      if (loaderStarted && !loaderStopped) {
        yield put({
          type: actionConstants.STOP_LOADER,
          payload: { actionType: actionTypeRequest },
        });
      }
    }
  }
}
